const Blockly = require('blockly');
const dataAccessMethods = require('../../../../dataAccessMethods');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');

const TOOLTIP =
    "Uses a dropdown criteria from the record selected in the Navigation to filter a given control's contents. E.g. Locations in an inventory. Requires to be on a Navigation Selected Context Page.";

function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    let workspace = blocklyBlock.workspace;
    let blockId = blocklyBlock.id;

    blocklyBlock.setTooltip(TOOLTIP);
    //set inputs to be arranged vertically.
    //Meaning each (dummy)input starts a new line
    blocklyBlock.setInputsInline(false);
    line1OfInputs
        .appendField('   Navigation Selection Namespace:')
        .appendField(new Blockly.FieldDropdown(dataAccessMethods.getNamespaces), 'namespace')
        .appendField('   Relation:')
        .appendField(new Blockly.FieldDropdown(() => dataAccessMethods.getRelations(workspace, blockId)), 'relation');

    //line 2 of inputs
    blocklyBlock
        .appendDummyInput()
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField('  Match Using Criteria For')
        .appendField('  Namespace:')
        .appendField(new Blockly.FieldDropdown(() => dataAccessMethods.getNamespaces(true)), 'foreignNamespace')
        .appendField('  Relation:')
        .appendField(
            new Blockly.FieldDropdown(() =>
                dataAccessMethods.getRelations(workspace, blockId, true, 'foreignNamespace')
            ),
            'foreignRelation'
        );
}

function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
    addCodeProperties(['namespace', 'relation', 'foreignNamespace', 'foreignRelation']);
    //we might never need/want the MDC user  to change this. But just in case put it on the code.
    code.criteriaProperty = 'criteria';
    return code;
}

/** Builds the filter metadata fragment for the ByNavigationSelectionDropdownCriteria block. */
function asDataDictionary(hNode, context) {
    const { namespace, relation, criteriaProperty, foreignNamespace, foreignRelation } = hNode;
    const criteriaElementPath = `${foreignNamespace}:${foreignRelation}`;
    //we don't know much. Hopefully from elsewhere there is a more complete definition.
    //But register what we know regardless, as that helps with finding incorrect configurations

    //we DO know that the navigated relation has a criteria object
    //And in it, there is at least 1 criteria: `propertyName`
    //We do NOT know what criteria operations it can contain, as that depends on if it is single, or multi select
    // We rely on registerForeignKey to declare the foreign namespace/relation exists.
    // The criteria structure is documented but not enforced in the data dictionary at this level.
    const subDataDictionary = {};
    //and we know that whatever relation context we are in, is expected to have this particular foreign key as property
    //but we don't know any fields on it
    // This filter identifies a foreign key; its requiredness must come from a form.
    const partialTypeDefinition = context.registerForeignKey(foreignNamespace, foreignRelation, []);

    //And the given foreignKey exists on the parent object.
    return [subDataDictionary, partialTypeDefinition];
}

module.exports = { addBlockSpecificFields, convertCustomFieldsToCode, asDataDictionary };
